import React, { memo, useEffect } from 'react';
import { EditIcon, InfoMark, LocationIcon } from '../../../../assests/icons/Icons';
import { useAppDispatch, useAppSelector } from '../../../../ReduxTool/store/hooks';
import { clearBoundryandDataModal } from '../../../../ReduxTool/Slice/Map/MapReducer';
import globalLayers from '../../../../Utils/CustomerMaps/Maps/GlobaLMap';
import Graphic from 'esri/Graphic';
import Polygon from "@arcgis/core/geometry/Polygon";
import { IconDeleteRed, Iconfly } from '../../../../assests/icons/EPCIcons/Icons';
import { getCurrencyLabel, convertACtoDC, convertRupeeToCurrency, formatCompactMoney, formatCompactNumber, readCachedEstimate, toFixed } from '../../../../Utils/commonFunctions';
import { setFormQuickPlantAnalysisData, setFromProjectSummeryData, setSelectedOption } from '../../../../ReduxTool/Slice/Consumer/ConsumerReducers';
import { setButtonLoader, setModalHeaderFooter } from '../../../../ReduxTool/Slice/CommonReducers/CommonReducers';
import ReactTooltip from '../../../../Components/ReactTooltip/ReactTooltip';
import { GInfoCard } from '../../../../Components/Card/NewInfoCard';
// import { MapPin, ChevronDown, Pencil } from 'lucide-react';

interface SolarReviewProps {
  // connectedLoad?: string;
  // totalRoofSize?: number;
  // solarInstallArea?: number;
  // roofType?: string;
  // electricityCompany?: string;
  // propertyType?: string;
  actionBtnLoading?: boolean;
}

const SolarReviewComponent: React.FC<SolarReviewProps> = ({ actionBtnLoading = false, }) => {
  const dispatch = useAppDispatch();
  const { roofAnalysis: { selected_project, formDetails: { projectSetup, quickplantAnalysis, projectSummary }, useableArea }, } = useAppSelector((state) => state.consumerReducers);
  const { user } = useAppSelector(state => state.auth);
  const { is3ddata } = useAppSelector((state) => state.mapref);

  const handleSiteAddress = () => {
    dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "", modalid: "" }));
    dispatch(setModalHeaderFooter({ title: "Site Address", btnTxt: "Save Address", secondaryBtnTxt: "Back", modalid: "siteaddressback" }));
  }

  
  const cardRightContent = () => {
    return (<>
    <button type="button"  onClick={handleSiteAddress} className=" size-4 flex items-center justify-center" > <EditIcon /> </button>
    </>)
  }

  const cardChildren = ()=>(
     <div className="flex w-full text-sm text-gray-700 gap-3"> 
       <div className="mt-[2px]" >  <LocationIcon /> </div>
       <div className="pr-2 overflow-hidden w-full">
           {/* <h4 className='heading-14-roboto-normal text-nowrap overflow-hidden text-ellipsis h-5'>{projectSetup?.addressline1 || projectSetup.address}</h4> */}
           <h4 className='heading-14-roboto-normal text-nowrap overflow-hidden text-ellipsis h-5'>{selected_project?.projectlocation?.address || projectSetup.address}</h4>
           <div className='w-full flex items-center gap-1'>
           <p className="text-12-roboto leading-normal h-4">{projectSetup?.state ? `${projectSetup?.city}, ${projectSetup?.state}, ${projectSetup?.country}, ${projectSetup?.pincode}` : ``} </p>
           </div>
       </div>
      </div>
  )

  return (
    <div className="mx-auto p-2 !pb-0  rounded-2xl font-sans text-slate-800">

      {/* Hero Load Display */}
      <div className="mb-6">
        <p className="text-sm font-medium text-slate-600 mb-1">Connected load (AC)</p>
        <h4 className="text-md font-semi text-slate-800">{projectSetup?.sanctionload ?? "--"} kW</h4>
      </div>

      <hr className="border-slate-400 mb-6" />

      {/* Details List */}
      <div className="space-y-3 mb-8">
        <DetailRow label="Total roof size" value={`${projectSetup.totalroofarea.toString()} sq m`} />
        <DetailRow label="Solar install area" value={`${is3ddata ? useableArea! : (projectSetup?.useablearea || 0 > 0) ? projectSetup?.useablearea?.toFixed(2) : projectSetup?.totalroofarea?.toFixed(2)} sq m`} />
        <DetailRow label="Roof type" value={` ${((projectSetup?.projecttype && Object.keys(projectSetup?.projecttype).length > 0) && projectSetup?.projecttype?.label !== null ? projectSetup?.projecttype?.value : null) ?? "--"}`} />
        <DetailRow label="Your electricity company" value={projectSetup?.providerid!?.label ?? (selected_project?.tariffconsumercategory_mstr?.tariffprovider_mstr?.providername ?? "--")} />
        <DetailRow label="Property type" value={` ${ projectSetup?.consumercategoryid?.label ?? (selected_project?.tariffconsumercategory_mstr?.consumercategoryname ?? "--")}`} />
      </div>

      {/* Address Card as same as site details */}
          <div>
            <GInfoCard noWrap title={<p  className="text-12-roboto leading-none flex items-center gap-1 uppercase"> SITE ADDRESS </p>} // <span data-tooltip-id="useraddresstooltip"> <InfoMark />   </span>
                    rightContent={cardRightContent()} subtitle={"Auto-filled from your selected map location. You can edit if needed."}  children={cardChildren()} /> </div>
        </div>
  );
};

// Helper component for rows to keep code DRY
const DetailRow = ({ label, value }: { label: string; value: string }) => (
  <div className="flex justify-between items-center">
    <span className="text-[12px] text-[rgba(0,0,0,1)]">{label}</span>
    <span className="text-[12px] font-inter  text-[rgba(17,63,74,1)]">{value}</span>
  </div>
);

export default SolarReviewComponent;

type StatsCardProps = { title: string; value: React.ReactNode; subtitle?: React.ReactNode;};

export const StatsCard = ({ title, value, subtitle }: StatsCardProps) => {
  return (
    <div className="flex flex-col gap-1 p-3 border border-gray-100 rounded-2xl bg-white shadow-sm">
      <p className="text-10-roboto">{title}</p>
      <div className="heading-16-roboto">{value}</div>
      {subtitle && <p className="text-10-roboto">{subtitle}</p>}
    </div>
  );
};

export const SolarSystemCard = memo(() => {
  const dispatch = useAppDispatch();
  const { roofAnalysis: { selected_project, formDetails: { projectSetup, quickplantAnalysis, projectSummary } }, } = useAppSelector((state) => state.consumerReducers);
  const { user } = useAppSelector(state => state.auth);
  // selected_project is briefly null while a saved project (re)loads; only a new, unsaved project
  // (no projectid stored) may show delete then, so a completed project never flashes the button
  const canDeleteRoof = selected_project ? !selected_project.iscompleted : !sessionStorage.getItem("projectid");

  // The estimate lives in memory and in this tab's session cache, but was only restored when the Get Estimate
  // modal opened. After a reload or a return from PayU the card fell back to projectcost (often not saved yet)
  // and showed 0; restore the cached estimate as soon as the project's inputs match it
  const estimateInputsKey = JSON.stringify([projectSetup?.sanctionload, projectSetup?.electricityrate, projectSetup?.lat, projectSetup?.lng, projectSetup?.useablearea, projectSetup?.totalroofarea]);
  useEffect(() => {
    if (parseFloat(quickplantAnalysis?.costbracket) > 0) return;
    const cached = readCachedEstimate(selected_project?.projectid || sessionStorage.getItem("projectid"), projectSetup);
    if (!cached) return;
    dispatch(setFormQuickPlantAnalysisData(cached.quickplantAnalysis));
    dispatch(setFromProjectSummeryData(cached.projectSummary));
    if (cached.selectedOption) dispatch(setSelectedOption(cached.selectedOption));
  }, [selected_project?.projectid, estimateInputsKey]);

  //  console.log("Prject summary  ->> " , selected_project)
  const handleRemoveRoof = () => {
    dispatch(clearBoundryandDataModal(true))
    // dispatch(setRoofDetailsError({}))
  }

  function handleFly() {
    if (!globalLayers.view) {
      console.warn("Map view is not available.");
      return;
    }
    if (!selected_project) {
      console.warn("No selected project to fly to.");
      return;
    }
    try {
      if (!selected_project.graphicLayer) {
        const { lat, lng } = selected_project;
        if (typeof lat !== "number" || typeof lng !== "number") {
          throw new Error("Invalid latitude or longitude in selected_project.");
        }
        // console.log(globalLayers.view)
        globalLayers.view?.goTo({
          target: [lng, lat],
          zoom: 18,
        });
        return;
      }

      let parsedGraphicLayer: Graphic | null = null;
      try {
        parsedGraphicLayer = JSON.parse(selected_project.graphicLayer) as Graphic;
      } catch (parseErr) {
        throw new Error("Failed to parse graphicLayer: " + (parseErr instanceof Error ? parseErr.message : String(parseErr)));
      }

      if (
        !parsedGraphicLayer ||
        !parsedGraphicLayer.geometry ||
        !(parsedGraphicLayer.geometry as Polygon).rings
      ) {
        throw new Error("Invalid geometry in parsed graphicLayer.");
      }

      globalLayers.zoomToGeometry(
        new Polygon({
          rings: (parsedGraphicLayer.geometry as Polygon).rings,
          spatialReference: parsedGraphicLayer.geometry.spatialReference,
        })
      );
    } catch (error) {
      if (error instanceof Error) {
        console.error("handleFly error:", error.message);
      } else {
        console.error("handleFly unknown error:", error);
      }
    }
  }

  const userCountryAlphaCode = user.country_mstr?.alpha2code;

 // `quickplantAnalysis` only lives in memory (populated while the "Get Estimate" modal is open);
 // `selected_project` is the persisted backend copy, so fall back to it once memory is empty
 // (e.g. right after a page reload, before the modal has been reopened).
 const estimatedCostSource = quickplantAnalysis?.costbracket && parseFloat(quickplantAnalysis.costbracket) > 0
   ? quickplantAnalysis.costbracket
   : selected_project?.projectcost;
 const savingPeriodSource = !isNaN(projectSummary?.degradation?.savingperiod ?? NaN) && (projectSummary?.degradation?.savingperiod ?? 0) > 0
   ? projectSummary?.degradation?.savingperiod
   : selected_project?.savingperiod;
 const savingPeriod = Math.round(Number(savingPeriodSource) || 0) || "--";

  const stats = [{ title: "Plant size (AC)", value: `${(projectSetup?.sanctionload) || "--"} kW solar system`, subtitle: `${projectSetup?.useablearea?.toFixed(2) ?? "--"} sq.m usable roof`,  },

      {title: "Estimated system cost", value: (
        <div className="flex items-baseline gap-1">   <span> {getCurrencyLabel(user?.country_mstr)} </span>
        <span>  {parseFloat(estimatedCostSource ?? "") > 0
          ? formatCompactNumber(  parseFloat(estimatedCostSource!) /  user.country_mstr?.currencyrate!,user?.country_mstr?.alpha2code  )
          : "--"}
           </span>
        {/* <span>  {formatCompactMoney(  parseFloat(selected_project?.projectcost??"0") /  user.country_mstr?.currencyrate!  )}   </span> */}
        <span className="heading-10-roboto">   (all inclusive) </span>
      </div>),
      subtitle: `${savingPeriod} years to recover cost`,
     },
   ]; 

  return (
    <div className="max-w-[34rem] bg-[rgba(217,217,217,0.16)] border border-gray-200 rounded-lg rounded-b-none p-3 shadow-sm font-sans">
      {/* Header Section */}
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-3">
          <h3 className="heading-16-roboto">{projectSetup.projectname}</h3>
          <span className="heading-10-roboto leading-none px-2 py-1 bg-gray-100 border border-[rgba(0,0,0,1)] rounded-full">
            In Design
          </span>
        </div>

        {/* buttons  */}
        <div className="flex gap-2">
          <div className="main-toolbox1 ">
            {/* {selected_project && <button className="toolbox-active1" data-tooltip-id={`roof_fly_map`} onClick={handleFly} ><Iconfly /></button>} */}
            {<button className="toolbox-active1" data-tooltip-id={`roof_fly_map`} onClick={handleFly} ><Iconfly /></button>}
            {canDeleteRoof && <button className="toolbox-active1" data-tooltip-id={`roof_deleteRoof`} disabled={false} onClick={handleRemoveRoof}><IconDeleteRed /></button>}
          </div>
        </div>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-2 gap-1">

        {stats?.map(item => (<StatsCard title={item.title} value={item.value} subtitle={item.subtitle} />))}



        
        {/* System Size Card */}
        {/* <div className="flex flex-col gap-1 p-3 border border-gray-100 rounded-2xl bg-white shadow-sm ">
          <p className="text-10-roboto">System size</p>
          <p className="heading-16-roboto">{projectSetup?.sanctionload || "--"} kWp solar system</p>
          <p className="text-10-roboto">{` ${projectSetup?.useablearea?.toFixed(2) ?? "--"}`} sq.m usable roof</p>
        </div> */}

        {/* Estimated Cost Card */}
        {/* <div className="flex flex-col gap-1 p-3 border border-gray-100 rounded-2xl bg-white shadow-sm ">
          <p className="text-10-roboto">Estimated system cost</p>
          <div className="flex items-baseline gap-1">
            <p className="heading-16-roboto">{getCurrencyLabel(user?.country_mstr)}{" "}
              {formatCompactMoney((parseFloat(quickplantAnalysis?.costbracket) / user.country_mstr?.currencyrate!))}</p>
            <span className="text-[10px] text-gray-500 font-medium">(all inclusive)</span>
          </div>
          <p className="text-10-roboto">{`${(Math.round(isNaN(projectSummary?.degradation?.savingperiod ?? 0) ? 0 : projectSummary?.degradation?.savingperiod ?? 0) || (selected_project?.savingperiod ?? 0)) || "--"}`} years to recover cost</p>
        </div> */}
      </div>
    </div>
  );
});

type CardHeaderProps = {
  title: string;
  status?: string;
  onFly?: () => void;
  onDelete?: () => void;
  disableDelete?: boolean;
};

export const CardHeader = ({
  title,
  status,
  onFly,
  onDelete,
  disableDelete,
}: CardHeaderProps) => {
  return (
    <div className="flex items-center justify-between mb-2">
      <div className="flex items-center gap-3">
        <h3 className="heading-16-roboto">{title}</h3>

        {status && (
          <span className="heading-10-roboto px-2 py-1 bg-gray-100 border border-black rounded-full">
            {status}
          </span>
        )}
      </div>

      <div className="flex gap-2">
        <div className="main-toolbox1">
          {onFly && (
            <button
              className="toolbox-active1"
              data-tooltip-id="roof_fly_map"
              onClick={onFly}
            >
              <Iconfly />
            </button>
          )}

          {onDelete && (
            <button
              className="toolbox-active1"
              data-tooltip-id="roof_deleteRoof"
              disabled={disableDelete}
              onClick={onDelete}
            >
              <IconDeleteRed />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
